import {ActionReducer, ActionReducerMap, createReducer, MetaReducer, on} from '@ngrx/store';
import {routerReducer, RouterReducerState} from '@ngrx/router-store';
import {
  loadServices,
  loadServicesFailure,
  loadServicesSuccess,
  loadSubpages,
  loadSubpagesFailure,
  loadSubpagesSuccess,
  login,
  loginFailure,
  loginGovPl,
  loginGovPlFailure,
  loginGovPlSuccess,
  loginSuccess,
  logout,
  setUISettings
} from '../actions/app.actions';
import {SubpageAppEntitySubpageRead} from '../../openapi';
import {applicationReducer, ApplicationState} from './application.reducer';
import {userDetailsReducer, UserDetailsState} from './user-details.reducer';
import {ServiceListItem} from '../../services/service.common.model';
import {myCasesReducer, MyCasesState} from './my-cases.reducer';
import {surveyReducer, SurveysState} from './surveys.reducer';
import {myBillsReducer, MyBillsState} from './my-bills.reducer';
import {municipalWasteReducer, MunicipalWasteState} from './municipal-waste.reducer';
import {civicBudgetReducer, CivicBudgetState} from './civic-budget.reducer';
import {SessionService, UISettings} from "../../services/ssession.service";
import {mySettingsReducer, MySettingsState} from "./my-settings.reducer";

export interface RootState {
  app: AppState;
  application: ApplicationState;
  router: RouterReducerState<any>;
  userDetails: UserDetailsState;
  myCases: MyCasesState;
  surveys: SurveysState;
  myBills: MyBillsState;
  municipalWaste: MunicipalWasteState;
  civicBudgets: CivicBudgetState;
  mySettings: MySettingsState;
}

export interface AppState {
  loading: number;
  pending: number;
  services: ServiceListItem[];
  subpages: SubpageAppEntitySubpageRead[];
  uiSettings: UISettings | null;
}

export const initialAppState: AppState = {
  loading: 0,
  pending: 0,
  subpages: [],
  services: [],
  uiSettings: SessionService.GetUISettings()
};

export const appReducer = createReducer(
  initialAppState,
  on(login, state => ({...state, pending: state.pending + 1})),
  on(loginSuccess, (state) => ({...state, pending: state.pending - 1})),
  on(loginFailure, state => ({...state, pending: state.pending - 1})),

  on(loadServices, (state) => ({...state, loading: state.loading + 1})),
  on(loadServicesSuccess, (state, action) => ({...state, loading: state.loading - 1, services: action.services})),
  on(loadServicesFailure, state => ({...state, loading: state.loading - 1})),

  on(loadSubpages, state => ({...state, loading: state.loading + 1})),
  on(loadSubpagesSuccess, (state, action) => ({...state, subpages: action.subpages, loading: state.loading - 1})),
  on(loadSubpagesFailure, (state) => ({...state, loading: state.loading - 1})),

  on(loginGovPl, state => ({
    ...state,
    pending: state.loading + 1
  })),
  on(loginGovPlSuccess, (state, action) => ({
    ...state,
    pending: state.loading - 1
  })),
  on(loginGovPlFailure, state => ({...state, pending: state.loading - 1})),
  on(setUISettings, (state, action) => ({...state, uiSettings: action.uiSettings})),
);

export const reducers: ActionReducerMap<RootState> = {
  app: appReducer,
  router: routerReducer,
  application: applicationReducer,
  userDetails: userDetailsReducer,
  myCases: myCasesReducer,
  surveys: surveyReducer,
  myBills: myBillsReducer,
  municipalWaste: municipalWasteReducer,
  civicBudgets: civicBudgetReducer,
  mySettings: mySettingsReducer
};

export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === logout.type) {
      state = {
        router: state.router
      };
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<RootState>[] = [clearState];
